var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76112 1.57436L8.30734 0.15775C8.08077 -0.055712 7.72205 -0.055712 7.51436 0.177155C7.30668 0.410022 7.30668 0.778729 7.53325 0.99219L8.09966 1.53555H1.32162C0.58529 1.53555 0 2.13712 0 2.89394V4.8345C0 5.16439 0.245444 5.41667 0.566409 5.41667C0.887375 5.41667 1.13282 5.16439 1.13282 4.8345V2.91334C1.13282 2.79691 1.20834 2.71929 1.32162 2.71929H8.09966L7.53325 3.26265C7.30668 3.47611 7.2878 3.84481 7.51436 4.07768C7.72205 4.31055 8.08077 4.32995 8.30734 4.09709L9.76112 2.68048C10.0632 2.38939 10.0821 1.90425 9.79888 1.59376C9.79888 1.59376 9.78 1.57436 9.76112 1.57436Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderRightArrowIcon);
export default __webpack_public_path__ + "static/media/headerRightArrowIcon.6554c18b552ae2334b323d3d874054d4.svg";
export { ForwardRef as ReactComponent };